import { createRouter, createWebHistory } from 'vue-router'

function loadPage (pagePath) {
  return () => import(`@/${pagePath}`);
}

const routes = [
  {
    path: '/sitedown',
    name: 'Sitedown',
    component: loadPage('views/Maintenance.vue')
  },
  {
    path: '/',
    name: 'Home',
    component: loadPage('views/Home.vue')
  },
  {
    path: '/:lang',
    name: 'LocalizedHome',
    component: loadPage('views/Home.vue')
  },
  {
    path: '/:lang/:page',
    name: 'LocalizedPage',
    component: loadPage('views/Home.vue')
  },
  {
    path: '/geoLimit',
    name: 'geo',
    component: loadPage('views/GeoLimit.vue')
  },
  {
    path: '/.wellknown*',
    name: 'security'
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'anyRootPath',
    component: loadPage('views/Home.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  linkActiveClass: 'active',
  routes
})

const VUE_APP_SITE_DOMAIN = process.env.VUE_APP_SITE_DOMAIN
let toLoop = true;
router.beforeEach((to, from, next) => {
  // Force HTTPS in production environment
  if (process.env.NODE_ENV === 'production' && 
      window.location.protocol === 'http:' && 
      window.location.hostname !== 'localhost') {
    window.location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
    return;
  }
  
  // if the user is not authenticated, `next` is called twice
  if (to.name === "security" && toLoop) {
    toLoop = false;
    window.location.href = `${VUE_APP_SITE_DOMAIN}.wellknown/security.txt`;
  } else {
    next();
  }
})

export default router
